import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { GetCompanyInfoResponse } from '@/api/my-business/agency-chains/get-company-info'

interface MockGetAgencyChainInfosPathParams {
  agencyChainAlphaId: string
}

export const mockGetAgencyChainInfos =
  http.get<MockGetAgencyChainInfosPathParams>(
    '/my-business/api/agency/v1/:agencyChainAlphaId/infos',
    () => {
      const response: GetCompanyInfoResponse = {
        active: faker.datatype.boolean(),
        companyId: faker.datatype.number({ min: 100000, max: 999999 }),
        alphaId: faker.string.uuid(),
        followingPolicy: faker.datatype.boolean(),
        legalData: {
          companyTypeCode: 'AGENCY_CHAIN',
          corporateName: faker.company.name(),
          municipalRegistration: faker.string.numeric(10),
          name: faker.company.name(),
          stateRegistration: faker.string.numeric(10),
          taxpayerId: faker.number
            .int({ min: 10000000000, max: 99999999999 })
            .toString(),
          observation: faker.lorem.sentence(),
        },
        responsibleData: {
          name: faker.person.fullName(),
          responsibleTaxpayerId: faker.number
            .int({ min: 10000000000, max: 99999999999 })
            .toString(),
          companyPosition: faker.person.jobTitle(),
        },
        contracts: {
          b2bContract: faker.internet.url(),
          socialContract: faker.internet.url(),
          inheritedFrom: faker.helpers.arrayElement([
            'AGENCY_CHAIN',
            'TRAVEL_AGENCY',
          ]),
        },
      }

      return HttpResponse.json(response, { status: 200 })
    },
  )
